//------------------------------------------------------------------------------
// 地区選択入力
//------------------------------------------------------------------------------
import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'redux-form';
import { useSelector } from 'react-redux';
import { renderAutocomplete } from '@/components/atoms/CustomPart';

/*
 * 地区選択入力コンポーネント (フォーム入力項目)
 */
function AreaSelectField({
  name, label,
  onChange, ...otherProps
}) {

  // 地区リスト
  const areaMaster = useSelector((state) => state.master.areaList) ?? [];
  const areaList = React.useMemo(() => areaMaster.map((m) => ({
    value: m.areaCode,
    label: m.areaCode + ' ' + m.areaName,  // 地区コード + 名称
  })), [areaMaster]);

  // 描画
  return (
    <Field
      name={name}
      label={label || '地区'}
      component={renderAutocomplete}
      options={areaList}
      onChange={onChange}
      fullWidth
      size="small"
      variant="standard"
      {...otherProps}
    />
  );
}

// プロパティ
AreaSelectField.propTypes = {
  name:       PropTypes.string.isRequired,    // フォーム項目名
  label:      PropTypes.string,               // 項目表示ラベル
  onChange:   PropTypes.func,                 // 変更ハンドラー
  otherProps: PropTypes.object,               // その他プロパティ
};

// デフォルトエクスポート
export default React.memo(AreaSelectField);
